import styled from 'styled-components'

const RepositiesFormStyled = styled.div`
  display: flex;
  align-items: center;
  height: 100vh;
  justify-content: center;
  position: relative;
  margin: 16px;
  .loading-bar {
    margin-block-end: 8px;
    .MuiLinearProgress-colorPrimary {
      background-color: #e2adcb;
    }
    .MuiLinearProgress-barColorPrimary {
      background-color: var(--secondary);
    }
  }
  .form {
    max-height: calc(100vh - 32px);
    overflow: auto;
    position: relative;
    border-radius: 8px;
    padding: 16px;
    background: var(--neutral90);
    max-width: 588px;
    flex-grow: 1;
    box-sizing: border-box;
    &-restart {
      width: 24px;
      height: 24px;
      background: red;
    }
    &-fieldset {
      border: none;
      border: none;
      padding-inline: 0px;
      padding-block: 0px;
      margin-inline: 0px;
      width: 100%;
    }
    &-btns {
      margin-top: 60px;
      display: grid;
      grid-template-columns: 1fr;
      column-gap: 16px;
      row-gap: 16px;
    }
    &-legend {
      font-weight: bold;
      font-size: 24px;
      line-height: 32px;
      color: var(--neutralText);
      opacity: .8;
      margin-bottom: 32px;
    }
    &-label {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 16px;
      span {
        display: block;
        margin-left: 8px;
        opacity: .8;
        &:first-of-type {
          color: var(--neutralText);
        }
      }
      .bold-span {
        font-weight: 700;
      }
    }
    &-info {
      position: relative;
    }
    &-input {
      display: block;
      height: 48px;
      box-sizing: border-box;
      padding: 12px 16px;
      border-radius: 4px;
      border: 1px solid var(--neutral60);
      display: flex;
      align-items: center;
      background: var(--white);
      margin-bottom: 4px;
      max-width: calc(100vw - 64px);
      input {
        width: 100%;
        margin-left: 10px;
        background: var(--white);
        color: var(--neutral80);
        font-family: var(--primaryFont);
        outline: none;
        border: none;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        padding: 0;
        line-height: 24px;
        &::placeholder {
          color: var(--neutral60);
        }
      }
    }
    &-state {
      align-self: flex-end;
      color: var(--secondary);
      display: flex;
      align-items: center;
      justify-content: center;
      svg {
        cursor: pointer;
      }
    }
    .close {
      float: right;
    }
  }
  @media(min-width: 375px) {
    .close {
      position: absolute;
      top: 24px;
      right: 24px;
      cursor: pointer;
    }
    .form-btns {
      grid-template-columns: 1fr 1fr;
    }
  }
  @media(min-width: 768px) {
    .form {
      height: 546px;
      padding: 24px;
      &-btns {
        position: absolute;
        right: 24px;
        bottom: 24px;
        grid-template-columns: repeat(2, min-content);
        justify-content: end;
      }
    }
  }
`

export default RepositiesFormStyled
